export const MOCK_TEAM_A_ID = 'MOCK_TEAM_A_ID'
